(function () {
  var catalogPromise = null;
  var catalogByCode = null;
  var fullCatalogLoaded = false;

  var getSectionUrl = function () {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    if (root.slice(-1) !== '/') {
      root += '/';
    }
    return root + '?sections=renk-varyant-catalog';
  };

  var parseCatalogPayload = function (html) {
    if (!html) {
      return { items: [], pages: 1, page: 1 };
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector('[data-renk-varyant-catalog]');

    if (!node) {
      return { items: [], pages: 1, page: 1 };
    }

    var text = (node.textContent || '').trim();
    var items = [];

    try {
      items = JSON.parse(text);
    } catch (error) {
      items = [];
    }

    return {
      items: Array.isArray(items) ? items : [],
      pages: Number(node.getAttribute('data-renk-varyant-pages')) || 1,
      page: Number(node.getAttribute('data-renk-varyant-page')) || 1,
    };
  };

  var fetchCatalogPage = function (page) {
    var url = getSectionUrl() + '&page=' + String(page);

    return fetch(url, {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('catalog');
        }

        return response.json();
      })
      .then(function (json) {
        return parseCatalogPayload(json['renk-varyant-catalog']);
      });
  };

  var ingestCatalogItems = function (items) {
    if (!Array.isArray(items) || items.length === 0) {
      return;
    }

    if (!catalogByCode) {
      catalogByCode = {};
    }

    items.forEach(function (item) {
      var code = String(item.code || '').trim();

      if (!code) {
        return;
      }

      if (!catalogByCode[code]) {
        catalogByCode[code] = [];
      }

      var token = String(item.id);
      var exists = catalogByCode[code].some(function (entry) {
        return String(entry.id) === token;
      });

      if (!exists) {
        catalogByCode[code].push(item);
      }
    });
  };

  var readInlineCatalog = function () {
    var merged = [];

    document.querySelectorAll('[data-renk-varyant-inline]').forEach(function (node) {
      try {
        var chunk = JSON.parse(node.textContent || '[]');

        if (Array.isArray(chunk)) {
          merged = merged.concat(chunk);
        }
      } catch (error) {}
    });

    if (merged.length > 0) {
      ingestCatalogItems(merged);
      return true;
    }

    return false;
  };

  var parseSectionPayload = function (html, selector) {
    if (!html) {
      return { items: [], pages: 1, page: 1 };
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);

    if (!node) {
      return { items: [], pages: 1, page: 1 };
    }

    var text = (node.textContent || '').trim();
    var items = [];

    try {
      items = JSON.parse(text);
    } catch (error) {
      items = [];
    }

    return {
      items: Array.isArray(items) ? items : [],
      pages: Number(node.getAttribute('data-renk-varyant-pages')) || 1,
      page: Number(node.getAttribute('data-renk-varyant-page')) || 1,
    };
  };

  var getProductHandleForFetch = function () {
    var pageRoot = document.querySelector('[data-product-page][data-product-handle]');

    if (pageRoot) {
      return String(pageRoot.getAttribute('data-product-handle') || '').trim();
    }

    var quickProduct = document.querySelector('[data-quick-view-product][data-product-handle]');

    if (quickProduct) {
      return String(quickProduct.getAttribute('data-product-handle') || '').trim();
    }

    return '';
  };

  var getStoreRoot = function () {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    if (root.slice(-1) !== '/') {
      root += '/';
    }

    return root;
  };

  var fetchSectionPages = function (buildUrl, sectionKey, selector) {
    return fetchSectionPagesFrom(buildUrl, sectionKey, selector, 1).then(function (first) {
      var allItems = first.items.slice();
      var totalPages = first.pages;

      if (totalPages <= 1) {
        return allItems;
      }

      var tasks = [];

      for (var page = 2; page <= totalPages; page += 1) {
        tasks.push(fetchSectionPagesFrom(buildUrl, sectionKey, selector, page));
      }

      return Promise.all(tasks).then(function (rest) {
        rest.forEach(function (chunk) {
          allItems = allItems.concat(chunk.items);
        });

        return allItems;
      });
    });
  };

  var fetchSectionPagesFrom = function (buildUrl, sectionKey, selector, page) {
    return fetch(buildUrl(page), {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(sectionKey);
        }

        return response.json();
      })
      .then(function (json) {
        return parseSectionPayload(json[sectionKey], selector);
      });
  };

  var fetchByCodePage = function (handle, page) {
    var root = getStoreRoot();

    var url =
      root +
      'products/' +
      encodeURIComponent(handle) +
      '?sections=renk-varyant-by-code&page=' +
      String(page);

    return fetch(url, {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('by-code');
        }

        return response.json();
      })
      .then(function (json) {
        return parseSectionPayload(json['renk-varyant-by-code'], '[data-renk-varyant-by-code]');
      });
  };

  var loadSiblingsByCollection = function (handle) {
    if (!handle) {
      return Promise.resolve([]);
    }

    var root = getStoreRoot();

    return fetchSectionPages(
      function (page) {
        return (
          root +
          'products/' +
          encodeURIComponent(handle) +
          '?sections=renk-varyant-by-collection&page=' +
          String(page)
        );
      },
      'renk-varyant-by-collection',
      '[data-renk-varyant-by-collection]'
    ).catch(function () {
      return [];
    });
  };

  var loadSiblingsByCode = function (handle) {
    if (!handle) {
      return Promise.resolve([]);
    }

    return fetchByCodePage(handle, 1).then(function (first) {
      var allItems = first.items.slice();
      var totalPages = first.pages;

      if (totalPages <= 1) {
        return allItems;
      }

      var tasks = [];

      for (var page = 2; page <= totalPages; page += 1) {
        tasks.push(fetchByCodePage(handle, page));
      }

      return Promise.all(tasks).then(function (rest) {
        rest.forEach(function (chunk) {
          allItems = allItems.concat(chunk.items);
        });

        return allItems;
      });
    });
  };

  var getCollectionHandleForFetch = function () {
    var page = document.querySelector('[data-collection-page][data-collection-handle]');

    if (!page) {
      return '';
    }

    return String(page.getAttribute('data-collection-handle') || '').trim();
  };

  var loadCollectionCatalog = function (collectionHandle) {
    if (!collectionHandle) {
      return Promise.resolve([]);
    }

    var root = getStoreRoot();

    return fetchSectionPages(
      function (page) {
        return (
          root +
          'collections/' +
          encodeURIComponent(collectionHandle) +
          '?sections=renk-varyant-collection-catalog&page=' +
          String(page)
        );
      },
      'renk-varyant-collection-catalog',
      '[data-renk-varyant-collection-catalog]'
    )
      .then(function (items) {
        ingestCatalogItems(items);
        return items;
      })
      .catch(function () {
        return [];
      });
  };

  var loadCatalog = function () {
    if (catalogPromise) {
      return catalogPromise;
    }

    catalogPromise = fetchCatalogPage(1)
      .then(function (first) {
        var allItems = first.items.slice();
        var totalPages = first.pages;

        if (totalPages <= 1) {
          return allItems;
        }

        var tasks = [];

        for (var page = 2; page <= totalPages; page += 1) {
          tasks.push(fetchCatalogPage(page));
        }

        return Promise.all(tasks).then(function (rest) {
          rest.forEach(function (chunk) {
            allItems = allItems.concat(chunk.items);
          });

          return allItems;
        });
      })
      .then(function (items) {
        ingestCatalogItems(items);
        fullCatalogLoaded = true;
        return items;
      })
      .catch(function () {
        return [];
      });

    return catalogPromise;
  };

  var escapeHtml = function (value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };

  var updateCardIndicators = function () {
    if (!catalogByCode) {
      return;
    }

    document.querySelectorAll('[data-renk-varyant-indicator]').forEach(function (node) {
      var code = String(node.getAttribute('data-renk-varyant-code') || '').trim();
      var countNode = node.querySelector('[data-renk-varyant-count]');
      var siblings = catalogByCode[code] || [];
      var initialCount = Number(node.getAttribute('data-renk-varyant-initial-count')) || 0;
      var count = siblings.length;

      if (initialCount > count) {
        count = initialCount;
      }

      if (count < 2) {
        node.setAttribute('hidden', '');
        return;
      }

      if (countNode) {
        countNode.textContent = String(count);
      }

      node.removeAttribute('hidden');
    });
  };

  var getSwatchLabel = function (item) {
    if (item.color) {
      return item.color;
    }

    if (item.title) {
      return item.title;
    }

    return '';
  };

  var resolveProductUrl = function (item) {
    var url = String(item.url || '').trim();

    if (url) {
      return url;
    }

    var handle = String(item.handle || '').trim();

    if (!handle) {
      return '';
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    if (root.slice(-1) !== '/') {
      root += '/';
    }

    return root + 'products/' + handle;
  };

  var bindSwatchNavigation = function () {
    if (document.documentElement.dataset.renkSwatchNavBound === 'true') {
      return;
    }

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('a.product-info__color-swatch');

        if (!link) {
          return;
        }

        if (link.closest('[data-quick-view-root]')) {
          return;
        }

        if (link.classList.contains('is-active')) {
          event.preventDefault();
          return;
        }

        var href = link.href || resolveProductUrl({ url: link.getAttribute('href'), handle: '' });

        if (!href) {
          return;
        }

        event.preventDefault();
        window.location.assign(href);
      },
      true
    );

    document.documentElement.dataset.renkSwatchNavBound = 'true';
  };

  var buildSwatchHtml = function (item, currentProductId, quickView) {
    var isActive = String(item.id) === String(currentProductId);
    var label = getSwatchLabel(item);
    var productUrl = resolveProductUrl(item);
    var imageHtml = '';

    if (item.image) {
      imageHtml =
        '<img class="product-info__color-swatch-image" src="' +
        escapeHtml(item.image) +
        '" alt="" width="60" height="60" loading="lazy">';
    }

    if (quickView) {
      return (
        '<button type="button" class="product-info__color-swatch' +
        (isActive ? ' is-active' : '') +
        '" data-quick-view-handle="' +
        escapeHtml(item.handle) +
        '" data-swatch-id="' +
        escapeHtml(item.id) +
        '"' +
        (isActive ? ' aria-current="true"' : '') +
        ' aria-label="' +
        escapeHtml(label) +
        '">' +
        imageHtml +
        '</button>'
      );
    }

    return (
      '<a class="product-info__color-swatch' +
      (isActive ? ' is-active' : '') +
      '" href="' +
      escapeHtml(productUrl) +
      '" data-swatch-id="' +
      escapeHtml(item.id) +
      '"' +
      (isActive ? ' aria-current="page"' : '') +
      ' aria-label="' +
      escapeHtml(label) +
      '">' +
      imageHtml +
      '</a>'
    );
  };

  var countSwatchesInContainer = function (container) {
    return container.querySelectorAll('a.product-info__color-swatch, button.product-info__color-swatch').length;
  };

  var getExistingSwatchIds = function (container) {
    var ids = {};

    container.querySelectorAll('[data-swatch-id]').forEach(function (node) {
      ids[String(node.getAttribute('data-swatch-id'))] = true;
    });

    return ids;
  };

  var mergeSiblingsIntoContainer = function (container, siblings, currentId, quickView) {
    var existingIds = getExistingSwatchIds(container);

    siblings.forEach(function (item) {
      var id = String(item.id);

      if (existingIds[id]) {
        return;
      }

      var wrapper = document.createElement('div');
      wrapper.innerHTML = buildSwatchHtml(item, currentId, quickView);
      var node = wrapper.firstElementChild;

      if (node) {
        container.appendChild(node);
        existingIds[id] = true;
      }
    });

    var total = countSwatchesInContainer(container);

    if (total >= 2) {
      container.removeAttribute('hidden');
    }

    if (siblings.length >= 2 && total >= siblings.length) {
      container.setAttribute('data-renk-varyant-fetched', 'true');
      container.removeAttribute('data-renk-varyant-ssr');
    }
  };

  var updateColorSwatches = function () {
    if (!catalogByCode) {
      return;
    }

    document.querySelectorAll('[data-product-info-color-swatches]').forEach(function (container) {
      var code = String(container.getAttribute('data-renk-varyant-code') || '').trim();
      var currentId = String(container.getAttribute('data-product-id') || '');
      var quickView = Boolean(container.closest('[data-quick-view-root]'));
      var siblings = catalogByCode[code] || [];
      var existingCount = countSwatchesInContainer(container);

      if (siblings.length < 2) {
        if (existingCount >= 2) {
          container.removeAttribute('hidden');
          return;
        }

        container.setAttribute('hidden', '');
        return;
      }

      if (existingCount >= 2) {
        mergeSiblingsIntoContainer(container, siblings, currentId, quickView);
        return;
      }

      var html = '';

      siblings.forEach(function (item) {
        html += buildSwatchHtml(item, currentId, quickView);
      });

      container.innerHTML = html;
      container.removeAttribute('hidden');
      container.setAttribute('data-renk-varyant-fetched', 'true');
      container.removeAttribute('data-renk-varyant-ssr');
    });
  };

  var applyCatalog = function () {
    updateCardIndicators();

    if (catalogByCode) {
      updateColorSwatches();
    }

    var quickViewContent = document.querySelector('[data-quick-view-content]');

    if (
      quickViewContent &&
      quickViewContent.querySelector('[data-quick-view-product]') &&
      typeof window.initQuickViewContent === 'function'
    ) {
      window.initQuickViewContent(quickViewContent);
    }

    document.dispatchEvent(new CustomEvent('renk-varyant:catalog-ready'));
  };

  var needsFullCatalogFetch = function () {
    return Boolean(document.querySelector('[data-renk-varyant-indicator]'));
  };

  var loadStoreSiblingsFallback = function (safeHandle) {
    return loadSiblingsByCode(safeHandle)
      .then(function (items) {
        ingestCatalogItems(items);

        if (items.length >= 2) {
          applyCatalog();
          return items;
        }

        return loadCatalog().then(function () {
          applyCatalog();
          return items;
        });
      })
      .catch(function () {
        return loadCatalog().then(applyCatalog);
      });
  };

  var mergeSiblingItems = function (collectionItems, codeItems) {
    var merged = [];
    var seen = {};
    var lists = [collectionItems, codeItems];

    lists.forEach(function (list) {
      if (!Array.isArray(list)) {
        return;
      }

      list.forEach(function (item) {
        var id = String(item.id);

        if (!id || seen[id]) {
          return;
        }

        seen[id] = true;
        merged.push(item);
      });
    });

    return merged;
  };

  var loadSiblingsForPage = function (handle) {
    var safeHandle = String(handle || '').trim();

    if (!safeHandle) {
      return loadCatalog().then(applyCatalog);
    }

    return Promise.all([
      loadSiblingsByCollection(safeHandle).catch(function () {
        return [];
      }),
      loadSiblingsByCode(safeHandle).catch(function () {
        return [];
      }),
    ])
      .then(function (pair) {
        var items = mergeSiblingItems(pair[0], pair[1]);
        ingestCatalogItems(items);

        if (items.length >= 2) {
          applyCatalog();
          return items;
        }

        return loadCatalog().then(function () {
          applyCatalog();
          return items;
        });
      })
      .catch(function () {
        return loadStoreSiblingsFallback(safeHandle);
      });
  };

  var init = function () {
    bindSwatchNavigation();
    readInlineCatalog();

    var swatchContainer = document.querySelector('[data-product-info-color-swatches]');
    var hasIndicators = document.querySelector('[data-renk-varyant-indicator]');
    var productPage = document.querySelector('[data-product-page]');

    if (!swatchContainer && !hasIndicators) {
      return;
    }

    if (swatchContainer) {
      var existingCount = countSwatchesInContainer(swatchContainer);

      if (existingCount >= 2) {
        swatchContainer.removeAttribute('hidden');
      }

      if (catalogByCode) {
        applyCatalog();
      }

      if (productPage) {
        loadSiblingsForPage(getProductHandleForFetch());

        if (!hasIndicators) {
          return;
        }
      } else {
        if (existingCount >= 2 && !hasIndicators) {
          return;
        }

        if (existingCount < 2) {
          var swatchCode = String(swatchContainer.getAttribute('data-renk-varyant-code') || '').trim();

          if (catalogByCode && swatchCode && catalogByCode[swatchCode] && catalogByCode[swatchCode].length >= 2) {
            applyCatalog();

            if (!hasIndicators) {
              return;
            }
          } else {
            loadSiblingsForPage(getProductHandleForFetch());

            if (!hasIndicators) {
              return;
            }
          }
        }
      }
    }

    if (hasIndicators) {
      if (catalogByCode) {
        applyCatalog();
      }

      var collectionHandle = getCollectionHandleForFetch();
      var indicatorTasks = [loadCatalog()];

      if (collectionHandle) {
        indicatorTasks.unshift(loadCollectionCatalog(collectionHandle));
      }

      Promise.all(indicatorTasks).then(applyCatalog);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('quick-view:loaded', function () {
    readInlineCatalog();

    var swatchContainer = document.querySelector(
      '[data-quick-view-root] [data-product-info-color-swatches]'
    );

    if (swatchContainer) {
      var existingCount = countSwatchesInContainer(swatchContainer);

      if (existingCount >= 2) {
        swatchContainer.removeAttribute('hidden');
        if (catalogByCode) {
          applyCatalog();
        }
        return;
      }
    }

    if (catalogByCode) {
      applyCatalog();
    }

    loadSiblingsForPage(getProductHandleForFetch());
  });

  window.initRenkVaryantSwatches = function () {
    bindSwatchNavigation();
    readInlineCatalog();

    if (catalogByCode) {
      applyCatalog();
      return;
    }

    loadCatalog().then(applyCatalog);
  };
})();
